$(".head-check").change(function () {
    $(this).removeClass("_halfChecked")
    if($(this).prop("checked")){
        $(".row-check").each(function (i,el) {
            $(el).prop("checked",true)
            $(".cart-nav").addClass("_active")
        })
    } else{
        $(".row-check").each(function (i,el) {
            $(el).prop("checked",false)
            $(".cart-nav").removeClass("_active")
        })
    }
})

$(".row-check").change(function () {
    setCartCheckboxes()
})

setCartCheckboxes()


function setCartCheckboxes(){
    let checked = []

    $(".row-check").each(function (i,el) {
        checked.push($(el).prop("checked"))
    })


    if(checked.indexOf(true) === -1){
        $(".head-check").removeClass("_halfChecked")
        $(".head-check").prop("checked",false)
        $(".cart-nav").removeClass("_active")
        return
    }

    $(".cart-nav").addClass("_active")
    if(checked.indexOf(false) === -1){
        $(".head-check").removeClass("_halfChecked")
        $(".head-check").prop("checked",true)
        return
    }

    $(".head-check").addClass("_halfChecked")
}
